import { Frame } from './frames';
import { LegacyFrames } from './legacyFrames';
export default function convertLegacyFrameToNewFrame(frame) {
    switch (frame.replace('photo', '')) {
        case LegacyFrames.AppleWatch:
        case LegacyFrames.AppleWatch38:
            return Frame.AppleWatch42;
        case LegacyFrames.S5:
        case LegacyFrames.Htc1:
        case LegacyFrames.Nexus5:
            return Frame.Nexus5;
        case LegacyFrames.Pixel4:
            return Frame.Pixel4;
        case LegacyFrames.DesktopWeb:
        case LegacyFrames.Web:
            return Frame.Web;
        case LegacyFrames.IPad:
            return Frame.IPad;
        case LegacyFrames.IPadPro11:
            return Frame.IPadPro11;
        case LegacyFrames.IPhone4:
        case LegacyFrames.IPhone4S:
            return Frame.IPhone4S;
        case LegacyFrames.IPhone5:
            return Frame.IPhone5;
        case LegacyFrames.IPhone5C:
            return Frame.IPhone5C;
        case LegacyFrames.IPhone6:
            return Frame.IPhone6;
        case LegacyFrames.IPhone6Plus:
            return Frame.IPhone6Plus;
        case LegacyFrames.IPhoneX:
            return Frame.IPhoneX;
        default:
            throw new Error("Unsupported frame: " + frame);
    }
}
